import React from "react";
import { BugFixLabel, FeatureLabel, LinkTo } from ".";

interface ChangelogArticleProps {
  date: string;
  header: string;
  labels?: ("feature" | "bugfix")[];
  children: React.ReactNode;
}
export const ChangelogArticle = ({
  date,
  header,
  children,
  labels = [],
}: ChangelogArticleProps): JSX.Element | null => {
  return (
    <article className="pt-6">
      <div className="xl:flex">
        <div className="w-32 shrink-0">
          <div className="text-xs font-semibold uppercase text-slate-400 dark:text-slate-500 xl:leading-8">{date}</div>
        </div>
        <div className="grow pb-2 border-b border-slate-200 dark:border-slate-700">
          <header>
            <h2 className="text-2xl text-slate-800 dark:text-slate-100 font-bold mb-3">{header}</h2>
            <div className="flex flex-nowrap items-center space-x-2 mb-2">
              <div className="flex items-center gap-2">
                {labels.map((label) =>
                  label === "feature" ? <FeatureLabel key={label} /> : <BugFixLabel key={label} />
                )}
              </div>
            </div>
          </header>
          {children}
        </div>
      </div>
    </article>
  );
};
